import request from "@/utils/request";

// 列表(主数据列表)
export function loadTableTasteListDataApi(data) {
    return request({
      url: "web/tableTaste/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadTableTasteExportDataApi(data) {
    return request({
      url: "web/tableTaste/exportData",
      method: "post",
      data
    });
  }
  // 导出图片
  export function loadTableTasteExportPicZipApi(data) {
    return request({
      url: "web/tableTaste/exportPicZip",
      method: "post",
      data
    });
  }
  // 导出痕迹化资料图片PDF
  export function loadTableTasteExportTracePicPDFApi(data) {
    return request({
      url: "web/tableTaste/exportTracePicPDF",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateTableTasteApi(data) {
    return request({
      url: "web/tableTaste/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initTableTasteApi(data) {
    return request({
      url: "web/tableTaste/initTableTaste",
      method: "post",
      data
    });
  }
  
  // 下拉列表（下拉选择）
  export function loadTableTasteListApi(data) {
    return request({
      url: "web/tableTaste/listSelectData",
      method: "post",
      data
    });
  }
  
  // 根据条件获取条数
  export function loadTableTasteCountByConditionApi(data) {
    return request({
      url: "web/tableTaste/findCountByCondition",
      method: "post",
      data
    });
  }

  
// 明细列表(主数据列表)
export function loadTableTasteMaterialsDetailListDataApi(data) {
  return request({
    url: "web/tableTasteMaterialsDetail/listData",
    method: "post",
    data
  });
}
// 明细导出
export function loadTableTasteMaterialsDetailExportDataApi(data) {
  return request({
    url: "web/tableTasteMaterialsDetail/exportData",
    method: "post",
    data
  });
}
// 根据条件获取一桌式品鉴物料明细
export function findTableTasteMaterialsDetailByConditionApi(data) {
  return request({
    url: "web/tableTasteMaterialsDetail/findTableTasteMaterialsDetailByCondition",
    method: "post",
    data
  });
}